class CollectionHelpers {
  static groupBy<K, V>(values: V[], keySelector: (value: V) => K): Map<K, V[]> {
    const map = new Map<K, V[]>();
    for (const value of values) {
      const key = keySelector(value);
      if (!map.has(key)) {
        map.set(key, []);
      }
      map.get(key)!.push(value);
    }
    return map;
  }
}

export default CollectionHelpers;
